export default __webpack_public_path__ + "static/media/positive-icon.d8dff3cb.svg";